// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "-" + {"packages_components_ui_pdf_pdfViewer_v1_0_0_pdfViewer_tsx": "c2afd5a76bfb6fdc","vendors-node_modules_pnpm_emotion_styled_11_11_0__emotion_react_11_14_0__types_react_18_3_23_-4c9719": "d25ed48fa97e35d2",}[chunkId] + ".js"
}